module.exports = __webpack_public_path__ + "img/logo_galp_vertical.f9abdc18.png";